import { Injectable } from '@angular/core';
import type { Timer } from '@freelancer/time-utils';
import { TimeUtils } from '@freelancer/time-utils';

@Injectable({ providedIn: 'root' })
export class RelativeTime {
  constructor(private timeUtils: TimeUtils) {}

  scheduleTick(tick: () => void, delay: number): Timer {
    return this.timeUtils.setInterval(tick, delay);
  }
}
